var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 336,
    viewBox: "0 0 512 336",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M503.172.276H361.931L2.703 333.218c1.589 1.539 3.737 2.506 6.124 2.506h141.241L509.297 2.782c-1.589-1.54-3.738-2.506-6.125-2.506z",
    fill: "#FFE15A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.931.276H8.828A8.828 8.828 0 0 0 0 9.103v317.793c0 2.488 1.047 4.717 2.703 6.322L361.931.276z",
    fill: "#73AF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.297 2.782L150.069 335.724h353.103a8.829 8.829 0 0 0 8.828-8.828V9.103c0-2.489-1.047-4.717-2.703-6.321z",
    fill: "#FF4B55"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCg);
export default __webpack_public_path__ + "static/media/cg.1d268b0dd5138edac3d946c8717a33ea.svg";
export { ForwardRef as ReactComponent };